import {
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
} from '@chakra-ui/react';
import * as React from 'react';

import { SelectButton } from '@/components/SelectButton';

enum TEXT_TYPE {
  PARAGRAPH = 'unstyled',
  HEADER_ONE = 'header-one',
  HEADER_TWO = 'header-two',
  HEADER_THREE = 'header-three',
  BLOCKQUOTE = 'blockquote',
}

const TEXT_TYPE_NAMES = new Map([
  [TEXT_TYPE.PARAGRAPH, 'Paragraph'],
  [TEXT_TYPE.HEADER_ONE, 'Heading 1'],
  [TEXT_TYPE.HEADER_TWO, 'Heading 2'],
  [TEXT_TYPE.HEADER_THREE, 'Heading 3'],
  [TEXT_TYPE.BLOCKQUOTE, 'Block Quote'],
]);

export const TextSelector: React.FC<{
  blockType: string;
  toggleBlockType: (newBlockType: string, setBold: boolean) => void;
}> = ({ blockType, toggleBlockType }) => {
  const selected =
    Object.values(TEXT_TYPE).find((obj) => obj === blockType) ??
    TEXT_TYPE.PARAGRAPH;

  return (
    <Menu>
      <MenuButton as={SelectButton}>{TEXT_TYPE_NAMES.get(selected)}</MenuButton>
      <MenuList
        zIndex={2} // Make sure the MenuList gets rendered above the DraftJS Editor
      >
        <MenuOptionGroup
          type="radio"
          value={selected}
          onChange={(newValue: TEXT_TYPE) => {
            toggleBlockType(
              newValue,
              newValue !== TEXT_TYPE.PARAGRAPH &&
                newValue !== TEXT_TYPE.BLOCKQUOTE
            );
          }}
        >
          <MenuItemOption value={TEXT_TYPE.PARAGRAPH}>
            {TEXT_TYPE_NAMES.get(TEXT_TYPE.PARAGRAPH)}
          </MenuItemOption>
          <MenuItemOption value={TEXT_TYPE.HEADER_ONE}>
            {TEXT_TYPE_NAMES.get(TEXT_TYPE.HEADER_ONE)}
          </MenuItemOption>
          <MenuItemOption value={TEXT_TYPE.HEADER_TWO}>
            {TEXT_TYPE_NAMES.get(TEXT_TYPE.HEADER_TWO)}
          </MenuItemOption>
          <MenuItemOption value={TEXT_TYPE.HEADER_THREE}>
            {TEXT_TYPE_NAMES.get(TEXT_TYPE.HEADER_THREE)}
          </MenuItemOption>
          <MenuItemOption value={TEXT_TYPE.BLOCKQUOTE}>
            {TEXT_TYPE_NAMES.get(TEXT_TYPE.BLOCKQUOTE)}
          </MenuItemOption>
        </MenuOptionGroup>
      </MenuList>
    </Menu>
  );
};
